import TextBlocks from '@/components/utilities/TextBlocks';
import VisibleLoading from '@/components/utilities/VisibleLoading';

const RichTextBlock = ({ richTextContent: content, richTextAlign: align, richTextAnimation: animation }) => {
  let classNameAlign = 'text-left';
  if (align === 'center') {
    classNameAlign = 'text-center mx-auto';
  } else if (align === 'right') {
    classNameAlign = 'text-right';
  }

  return (
    <VisibleLoading delay={200} disabled={!animation}>
      {({ ref, className }) => (
        <div ref={ref} className={`my-4 ${classNameAlign} ${className || ''}`.trim()}>
          <TextBlocks template={content} />
        </div>
      )}
    </VisibleLoading>
  );
};
export default RichTextBlock;
